import { Box, Text } from "@draftkings/arena-web";
import * as React from "react";
export const FinalScore = React.memo(function FinalScore(props) {
    const { selectionId, finalScore, result } = props;
    return React.createElement(Box, { marginBottom: "$s0", testId: 'final-score' },
        result && React.createElement(Text, { as: "span", testId: `final-score-result-${selectionId}`, variant: "selectionCardText" }, result),
        React.createElement(Text, { as: "span", testId: `final-score-${selectionId}`, variant: "finalScore" }, finalScore));
});
//# sourceMappingURL=FinalScore.js.map